export default __webpack_public_path__ + "static/268-3bfdb4b39192b97cec158dbcf81ae017.gif";